import { useTranslation } from 'react-i18next';

import { CompanyUser, Registration } from '@legacy-types';

import { SecurityQuestionsWarning } from './SecurityQuestionsWarning';
import { useSelector } from 'react-redux';
import { selectCompany, selectCompanyRegistration } from '@legacy-redux/preferences/selectors';
import { PropsWithClassName } from '@shared/utils/types';

export function SecurityQuestionsWarnings({ className }: PropsWithClassName) {
  const { t } = useTranslation();

  const company: CompanyUser = useSelector(selectCompany);
  const registration: Registration = useSelector(selectCompanyRegistration);

  if (!registration || !company) {
    return null;
  }

  const { materialAdmin, gatekeepingAdmin, crewAdmin } = company;

  if (!(materialAdmin || gatekeepingAdmin || crewAdmin)) {
    return null;
  }

  const { completedSafetyQuestions, completedSubcontractors, frozenAt } = registration;
  const eventName = registration.event.name;

  if (!completedSubcontractors) {
    return (
      <SecurityQuestionsWarning
        text={t('SubContractorsNotComplete', { eventName })}
        action={{ url: '/company', label: t('Complete') }}
        className={className}
      />
    );
  }

  if (!completedSafetyQuestions) {
    return (
      <SecurityQuestionsWarning
        text={t('SecurityQuestionsNotComplete', { eventName })}
        action={{ url: '/company/security-questions', label: t('Complete') }}
        className={className}
      />
    );
  }

  if (frozenAt) {
    return <SecurityQuestionsWarning text={t('RegistrationFrozen')} className={className} />;
  }

  return null;
}
